import "./App.css";

import Header from "./components/Header.jsx";

import QuoteSection from "./components/QuoteSection.jsx";
import { Routes, Route } from "react-router-dom";

import Footer from "./components/Footer.jsx";
import GlobalHtmlStyles from "./components/GlobalHtmlStyles.jsx";
import Reviews from "./components/Reviews.jsx";
import NotFound from "./components/NotFound.jsx";
import ServiceDetails from "./components/ServiceDetails.jsx";
import WisdomQuote from "./components/WisdomQuote.jsx";
import CompanyValues from "./components/CompanyValues.jsx";
import Sequence from "./components/Sequence.jsx";
import Results from "./components/Results.jsx";
import Education from "./components/Education.jsx";
import FinalQuote from "./components/FinalQuote.jsx";
import SEO from "./components/SEO.jsx";

function App() {
  return (
    <div className="App">
      <GlobalHtmlStyles>
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Клінінг в Ужгороді | Sweet Clean"
                  description="Професійний клінінг в Ужгороді. Післяорендне прибирання, післяремонтне прибирання, клінінг для бізнесу."
                  url="https://sweet-clean.com.ua/"
                />
                <QuoteSection />
                <WisdomQuote />
                <CompanyValues />
                <Sequence />
                <Results />
                <Education />
                <Reviews />
                <FinalQuote />
                <Footer />
              </>
            }
          />
          <Route path="*" element={<NotFound />} />
          <Route path="serviceDetails/:tab" element={<ServiceDetails />} />
        </Routes>
      </GlobalHtmlStyles>
    </div>
  );
}

export default App;
